import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
export const MessageBoxLayout = styled(Inset) `
  max-width: 672px;
  margin-inline: auto;

  @media ${query.lessThanMedium} {
    margin: 0 ${spacing.large}px;
  }
`;
